var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "#13ACC5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.16193 4.14878L4.70656 0.144512C4.81245 0.0512195 4.95362 0 5.1031 0C5.25259 0 5.39376 0.0512195 5.49757 0.144512L5.83182 0.439024C6.04982 0.631098 6.04982 0.943902 5.83182 1.13415L2.01383 4.49817L5.83598 7.86585C5.94186 7.95732 5.99999 8.08171 5.99999 8.21341C5.99999 8.34512 5.94186 8.46951 5.83598 8.56098L5.50172 8.85549C5.39584 8.94878 5.25674 9 5.10726 9C4.95778 9 4.8166 8.94878 4.71279 8.85549L0.16193 4.84756C0.0560477 4.75427 -0.00208342 4.62988 -7.27684e-06 4.49817C-0.00208342 4.36646 0.0560477 4.24207 0.16193 4.14878Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.09a9858e6432b50b7face862c07405b3.svg";
export { ForwardRef as ReactComponent };